<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar curso completado' : 'Registrar curso completado' }}</h2>

<mat-dialog-content [formGroup]="form">
  <p>
    Empleado: <strong>{{ data.user.name }} {{ data.user.surnames }}</strong>
  </p>

  <mat-form-field class="w-100">
    <mat-label>Formación</mat-label>
    <mat-select formControlName="learning_resource_id">
      @for (learning_resource of learning_resources(); track learning_resource.id) {
        <mat-option [value]="learning_resource.id">{{ learning_resource.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Fecha inicio</mat-label>
    <input matInput [matDatepicker]="start_picker" formControlName="start_date" />
    <mat-datepicker-toggle matSuffix [for]="start_picker"></mat-datepicker-toggle>
    <mat-datepicker #start_picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Fecha fin</mat-label>
    <input matInput [matDatepicker]="end_picker" formControlName="end_date" />
    <mat-datepicker-toggle matSuffix [for]="end_picker"></mat-datepicker-toggle>
    <mat-datepicker #end_picker></mat-datepicker>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()" [disabled]="loading()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" (click)="save()" [disabled]="loading() || form.invalid">Guardar</button>
</mat-dialog-actions>
